import DelBox from '../comps/DelBox';
import AddDepart from '../models/AddDepart';
import { useEffect, useState, useRef } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import AddTest from '../models/AddTest';
import AddTestParam from '../models/AddTestParam';
import { toast } from 'react-toastify';
import parse from 'html-react-parser';
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Select from 'react-select';


const RenderWithLimit = ({ html, wordLimit = 10 }) => {
  const [expanded, setExpanded] = useState(false);

  const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const text = stripHtml(html || "");
  const words = text.split(/\s+/).filter(Boolean);

  if (expanded || words.length <= wordLimit) {
    return (
      <div>
        {parse(html || "")}
        {words.length > wordLimit && (
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={() => setExpanded(false)}
          >
            Show Less
          </button>
        )}
      </div>
    );
  }

  const shortText = words.slice(0, wordLimit).join(" ") + "...";

  return (
    <div>
      {shortText}{" "}
      <button
        type="button"
        className="btn btn-link p-0"
        onClick={() => setExpanded(true)}
      >
        More
      </button>
    </div>
  );
};

const TestParams = () => {
  const DEFAULT_PAGE_SIZE = 20;

  const [isAdmin, setIsAdmin] = useState(false);
  const [formData, setFormData] = useState({
    l1: [],
    test_id: "",
    test_cat: "",
    cats: [],
    tests: [],
    page_no: 0,
    alertMsg: '',
    alertMsgTyp: '',
    search_key: '',
    isAlert: false,
  });

  const [ldata, setLdata] = useState(null);
  const [editItem, setEditItem] = useState(null);

  // DataTable client-side pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_PAGE_SIZE);

  // Searchable "All Tests" input state
  const [testSearchTerm, setTestSearchTerm] = useState("");
  const [showTestOptions, setShowTestOptions] = useState(false);
  const testDropdownRef = useRef(null);

  const initData = async (testIdArg) => {
    const storedData = sessionStorage.getItem("ldata");
    const userData = JSON.parse(sessionStorage.getItem("ldata") || "{}");
    const roleId = userData?.role_id;
    setIsAdmin(roleId === 1 || roleId === "1");
  
    if (!storedData) return;
  
    const fd = new FormData();
    fd.append('page_no', formData.page_no + "");
    // use the argument if provided, otherwise read from state
    const effectiveTestId = (typeof testIdArg !== 'undefined') ? testIdArg : formData.test_id;
    fd.append('test_id', effectiveTestId + "");
    fd.append('test_cat', formData.test_cat + "");
    fd.append('search_key', formData.search_key + "");
    //fd.append('test_param_user', 1 + "");
  
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.getTestParamListUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data?.status && response.data?.records) {
        setFormData(prev => ({ ...prev, l1: response.data.records }));
      } else {
        setFormData(prev => ({ ...prev, l1: [] }));
      }
    } catch (err) {
      console.error("getTestParamListUrl error:", err);
      setFormData(prev => ({ ...prev, l1: [] }));
    }
  
    // categories (unchanged)
    try {
      const fd1 = new FormData();
      fd1.append('cat_type', "department");
      fd1.append('page_no', "none");
      fd1.append('search_key', "");
      fd1.append('par_by', 1 + "");
      const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd1, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data?.status && response.data?.records) {
        setFormData(prev => ({ ...prev, cats: response.data.records }));
      }
    } catch (err) {
      console.error("getCatListUrl error:", err);
    }
  };
  

  const getTests = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (!storedData) return;
    const fd1 = new FormData();
    fd1.append('page_no', "none");
    fd1.append('search_key', "");
    fd1.append('test_user', 1 + "");
    fd1.append('test_cat', formData.test_cat + "");

    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd1, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data?.status && response.data?.records) {
        setFormData(prev => ({ ...prev, tests: response.data.records }));
      }
    } catch (err) {
      console.error("getTestListUrl (tests) error:", err);
    }
  };

  useEffect(() => {
    getTests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.test_cat]);

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.test_id]);

  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
      initData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // returns true on success
  const delItem = async (item) => {
    if (!item) return false;
    const fd = new FormData();
    fd.append('test_param_id', item.test_param_id + "");
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.delTestParamUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data?.status) {
        await initData();
        toast.success("Test Parameter deleted successfully");
        return true;
      } else {
        toast.error(response.data?.message || "Delete failed");
        return false;
      }
    } catch (err) {
      console.error("delTestParam error:", err);
      toast.error("Server error while deleting");
      return false;
    }
  };

  const handleAddDepart = () => {
    setFormData(prev => ({ ...prev, page_no: 0 }));
    initData();
  };

  const filteredList = formData.search_key.trim() === ""
    ? formData.l1
    : formData.l1.filter(item =>
      (`${item.test_param_name}`.toLowerCase().includes(formData.search_key.toLowerCase()) ||
        `${item.test_param_type}`.toLowerCase().includes(formData.search_key.toLowerCase()))
    );

  // Tests filter for searchable dropdown
  const filteredTestsForDropdown = (formData.tests || []).filter(t =>
    (t.test_name || "").toString().toLowerCase().includes(testSearchTerm.toLowerCase())
  );

  // Close test dropdown when clicking outside
  useEffect(() => {
    const onClickOutside = (e) => {
      if (testDropdownRef.current && !testDropdownRef.current.contains(e.target)) {
        setShowTestOptions(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  // DataTable columns
  const columns = [
    {
      name: '',
      width: '80px',
      cell: (row) => (
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            type="button"
            //disabled={!isAdmin}
            //style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
            onClick={() => {
              setEditItem(row);
              document.getElementById("addbt453")?.click();
            }}
            className="btn btn-warning btn-sm"
          >
            <i className="ri-pencil-fill fs-16"></i>
          </button>

          {/* <button
            type="button"
            disabled={!isAdmin}
            style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
            onClick={async () => {
              const result = await Swal.fire({
                title: 'Are you sure?',
                text: "This parameter will be permanently deleted!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Yes, delete it!',
              });

              if (result.isConfirmed) {
                const ok = await delItem(row);
                if (ok) {
                  Swal.fire({ icon: 'success', title: 'Deleted!', timer: 1200, showConfirmButton: false });
                }
              }
            }}
            className="btn btn-danger btn-sm"
          >
            <i className="ri-delete-bin-5-fill fs-16"></i>
          </button> */}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true
    },
    {
      name: 'SN',
      width: '80px',
      cell: (row, rowIndex) => ((currentPage - 1) * rowsPerPage + (rowIndex || 0) + 1)
    },
    {
      name: 'Parameter Name',
      selector: row => row.test_param_name || '-',
      sortable: true,
      wrap: true,
      grow: 2
    },
    // {
    //   name: 'Unit',
    //   selector: row => row.test_param_method || '-',
    //   sortable: true,
    //   width: '140px'
    // },
    {
      name: 'Unit',
      selector: row => row.test_range_type || '-',
      sortable: true,
      width: '120px'
    },
    {
      name: 'From',
      selector: row => row.test_param_from_range || '-',
      cell: row => <RenderWithLimit html={row.test_param_from_range} wordLimit={12} />,
      grow: 2,
      wrap: true
    },
    {
      name: 'To',
      selector: row => row.test_param_to_range || '-',
      width: '120px'
    },
    {
      name: 'Method',
      selector: row => row.test_param_method || '-',
      width: '140px'
    }
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f8f9fb',
        color: '#405189',
        fontSize: '13px',
        fontWeight: '600'
      }
    },
    rows: {
      style: {
        minHeight: '48px'
      }
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm">
                    <h2 className="card-title mb-0" style={{ color: "#405189" }}>Test Parameters</h2>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      <button id="addbt453" style={{ display: "none" }} type="button" className="btn btn-success add-btn" data-bs-toggle="modal" data-bs-target="#showModal"></button>
                      <button type="button" className="btn btn-success add-btn" onClick={(e) => {
                        e.preventDefault();
                        setEditItem(null);
                        document.getElementById("addbt453").click();
                      }}>
                        <i className="ri-add-line align-bottom me-1"></i> Add Parameter
                      </button>
                      <button className="btn btn-soft-danger" id="remove-actions">
                        <i className="ri-delete-bin-2-line"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body border border-dashed border-end-0 border-start-0">
                <form>
                  <div className="row g-3">
                    {/* SEARCHABLE Tests INPUT */}
                   {/* inside TestParams JSX: replace the old "All Tests" block with this */}
<div className="col-md-4">
  <label className="form-label">All Tests</label>

  <Select
    isClearable
    placeholder="Search test by name..."
    options={(formData.tests || []).map(t => ({
      value: t.test_id,
      label: t.test_name,
      meta: t.test_sample_type // additional info if you like
    }))}
    value={(formData.tests || []).find(t => String(t.test_id) === String(formData.test_id)) 
            ? { value: formData.test_id, label: formData.tests.find(t => String(t.test_id) === String(formData.test_id))?.test_name }
            : null}
            onChange={(opt) => {
              const newTestId = opt ? opt.value : "";
              // update state and reset paging in one setState
              setFormData(prev => ({ ...prev, test_id: newTestId, page_no: 0 }));
              setTestSearchTerm(opt ? opt.label : "");
              // call initData with the fresh id to avoid stale-state issue
              initData(newTestId);
            }}
            
    getOptionLabel={(o) => o.label}
    getOptionValue={(o) => o.value}
    styles={{
      // small style tweaks so it fits your bootstrap look
      control: (provided) => ({ ...provided, minHeight: '38px', borderRadius: 4 }),
      menu: (provided) => ({ ...provided, zIndex: 3000 })
    }}
    noOptionsMessage={() => "No tests found"}
  />
</div>


                    <div className="col-md-4" style={{ textAlign: "right" }}>
                      <div className="search-box">
                        <input className="form-control search" name="search_key" onChange={handleChange} value={formData.search_key} placeholder="Search..." type="text" />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <br />
              <div className="card-body pt-0">
                <div className="table-responsive table-card mb-1">
                  <DataTable
                    columns={columns}
                    data={filteredList}
                    pagination
                    paginationPerPage={rowsPerPage}
                    onChangePage={(page) => setCurrentPage(page)}
                    onChangeRowsPerPage={(newPerPage, page) => {
                      setRowsPerPage(newPerPage);
                      setCurrentPage(1);
                    }}
                    highlightOnHover
                    pointerOnHover
                    responsive
                    customStyles={customStyles}
                    noHeader
                    striped
                    persistTableHead
                  />
                </div>

                <div className="d-flex justify-content-end">
                  <div className="pagination-wrap hstack gap-2">
                    {/* DataTable provides pagination controls */}
                  </div>
                </div>

                <AddTestParam item={editItem} onAddDepart={handleAddDepart} />
                <DelBox />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestParams;
